import { UserRole, UserStatus } from "~/gql/graphqlBase.generated";
import { CommissionUserLookupFragment } from "~/gql/queries/commissions.generated";

export const RATE_MIN = 0;
export const RATE_MAX = 100;

export const formatRatePercent = (value: number): string => `${value.toFixed(2)}%`;

export const isValidRatePercent = (value: number): boolean =>
	Number.isFinite(value) && value >= RATE_MIN && value <= RATE_MAX;

const COMMISSION_ELIGIBLE_ROLES: UserRole[] = [UserRole.Sales, UserRole.SalesManager];

export const isCommissionEligibleUser = (roles: UserRole[]): boolean =>
	roles.some((role) => COMMISSION_ELIGIBLE_ROLES.includes(role));

export const commissionEligibleUsersWithoutConfig = (
	users: CommissionUserLookupFragment[],
	configuredUserIds: Set<string>
): CommissionUserLookupFragment[] =>
	users.filter(
		(user) =>
			user.status === UserStatus.Active && isCommissionEligibleUser(user.roles) && !configuredUserIds.has(user.userId)
	);
